import Animate from "./Animate";

export default {
    selector: '.header-block',
    previousElement: null,
    init() {
        this.headerBlocks = document.querySelectorAll(this.selector);
        if(this.headerBlocks && this.headerBlocks.length > 0) {
            //the height of the headerBlocks.
            let wrapper = this.headerBlocks[0].parentElement;
            this.oldHeight = wrapper.getBoundingClientRect().height;
            this.padding = parseInt(window.getComputedStyle(this.headerBlocks[0]).getPropertyValue('padding-top')) +
                parseInt(window.getComputedStyle(this.headerBlocks[0]).getPropertyValue('padding-bottom'));
            wrapper.style.height = this.oldHeight + "px";

            Array.from(this.headerBlocks).forEach(block => {
                if(!block.classList.contains('active')) {
                    let hover = (e) => {
                        this.hoverBegin(e, block, wrapper)
                    };
                    block.addEventListener('mouseenter', hover);
                }
            })

            if(wrapper) {
                wrapper.addEventListener('mouseleave', e => {
                    let active = document.querySelectorAll(this.selector+".active");
                    let _this = this;
                    this.removeActiveTags();
                    wrapper.style.height = this.oldHeight + "px";
                })
            }
        }
    },

    /**
     *
     * @param {MouseEvent} e mouse over the block
     * @param {HTMLElement} block The current block
     * @param {HTMLElement} wrapper The blocks parent
     */
    hoverBegin(e, block,  wrapper) {
        this.removeActiveTags();
        block.classList.add('active');
        let _this = this;
        this.toggleContent(block, 'forwards', () => {
            _this.calculateHeight(block, wrapper);
        });
    },

    toggleContent(el, direction, callback = null) {
        direction = direction.toLowerCase();
        let hover = el.querySelector(this.selector + "__hover"),
            content = el.querySelector(this.selector + "__content");

        if(!hover || !content) {
            throw new Error("HeaderBlock - " + this.selector + " must contain __header and __content");
        }

        switch(direction) {
            case "forwards" :
                this.showContent(hover, content, callback)
                break;
            case "reverse" :
            case "backwards" :
            default:
                this.showContent(content, hover, callback)
        }
    },

    /**
     *
     * @param {HTMLElement} toShow element to show
     * @param {HTMLElement} toHide element to hide
     * @param {function} callback
     */
    showContent(toShow, toHide, callback = null) {
        let hideAnimation = new Animate({
            animationDelay: 0,
            animationDuration: 150,
            el: toHide,
            animationName: 'hover-fade-out',
            callback: () => {
                if(hideAnimation.playing) {
                    toHide.style.display = "none";
                    toShow.style.display = "block";
                    if (callback) {
                        callback();
                    }
                    let showAnimation = new Animate({
                        animationDelay: 0,
                        animationDuration: 150,
                        el: toShow,
                        animationName: 'hover-fade-in',
                    })
                    showAnimation.play();
                }
            }
        })
        hideAnimation.play();
    },

    /**
     * Calculating new height for header
     * @param el element to get children of so we can calculate heihgt
     * @param wrapper the parent element to apply height to
     */
    calculateHeight(el, wrapper) {
        this.previousElement = el;
        let newHeight = 0;
        el.childNodes.forEach(child => {
            if(child.getBoundingClientRect) {
                newHeight += child.getBoundingClientRect().height;
                newHeight += parseInt(window.getComputedStyle(child).getPropertyValue('margin-top'));
                newHeight += parseInt(window.getComputedStyle(child).getPropertyValue('margin-bottom'));
            }
        })

        newHeight += this.padding;
        if(newHeight <= this.oldHeight) newHeight = this.oldHeight;
        wrapper.style.height = newHeight + "px";
    },

    /**
     * Ensuring no animations are playing and ensure the original content is showing.
     */
    removeActiveTags() {
        let active = document.querySelectorAll(this.selector+".active");
        Array.from(active).forEach(activeEl => {
            let hover = activeEl.querySelector(this.selector + "__hover"),
                content = activeEl.querySelector(this.selector + "__content");
            if(hover.animation) {
                hover.animation.cancel();
            }
            if(content.animation) {
                content.animation.cancel();
            }
            content.style.display="block";
            hover.style.display="none";
            activeEl.classList.remove('active');
            this.toggleContent(activeEl, 'reverse');
        })
    }
}